/* ==========================================================================
   DS PRODUCT JS v1  |  <ds-product> behavior for sections/ds-main-product.liquid
   Upload to: assets/ds-product.js (loaded with defer)
   Variants, gallery, zoom, add to cart (via DSCore), sticky bar, deal timer, share,
   Klaviyo back in stock, wishlist and compare (Ella storage), compare colors.
   ========================================================================== */
if (!customElements.get('ds-product')) {
  customElements.define('ds-product', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready || !this.isConnected) return;
      const json = this.querySelector('[data-product-json]');
      if (!json) return;
      this._ready = true;
      this.data = JSON.parse(json.textContent);
      this.form = this.querySelector('form[data-ds-form]');
      this.idInput = this.querySelector('[data-variant-input]');
      this.atc = this.querySelector('[data-atc]');
      this.msg = this.querySelector('[data-msg]');
      this.sets = Array.from(this.querySelectorAll('[data-opt]'));
      this.low = parseInt(this.dataset.low, 10) || 0;
      this.current = this.data.variants.find((v) => this.idInput && String(v.id) === this.idInput.value) || this.data.variants[0];

      this.sets.forEach((fs) => fs.addEventListener('change', () => this.onOption()));
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => this.step(parseInt(b.dataset.qty, 10))));
      this.setupGallery();
      this.setupSticky();
      this.setupDeal();
      this.setupShare();
      this.setupNotify();
      this.setupActions();
      this.setupCompareColors();
      if (this.current && this.current.media) this.goToMedia(this.current.media, true);
    }

    /* ---------- Variants ---------- */
    selected() {
      return this.sets.map((fs) => {
        const c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    onOption() {
      const sel = this.selected();
      const v = this.data.variants.find((x) => x.options.every((o, i) => o === sel[i]));
      this.sets.forEach((fs, i) => {
        const label = fs.querySelector('[data-opt-label]');
        if (label) label.textContent = sel[i] || '';
        fs.querySelectorAll('input').forEach((input) => {
          const ok = this.data.variants.some((x) => x.available && x.options[i] === input.value && x.options.every((o, k) => k === i || o === sel[k]));
          const lab = input.nextElementSibling;
          if (lab) lab.classList.toggle('is-unavailable', !ok);
        });
      });
      this.setVariant(v || null);
    }

    setVariant(v) {
      this.current = v;
      const label = this.querySelector('[data-atc-label]');
      const dyn = this.querySelector('[data-dyn]');
      const notify = this.querySelector('[data-notify]');
      const stickyBtn = this.querySelector('[data-sticky-btn]');
      const available = !!(v && v.available);
      const text = !v ? 'Unavailable' : (available ? (this.data.atcLabel || 'Add to cart') : 'Sold out');

      if (this.atc) this.atc.disabled = !available;
      if (label) label.textContent = text;
      if (stickyBtn) { stickyBtn.disabled = !available; stickyBtn.textContent = available ? 'Add to cart' : text; }
      if (dyn) dyn.hidden = !available;
      if (notify) notify.hidden = !v || available;
      if (this.msg) { this.msg.textContent = ''; this.msg.classList.remove('is-error'); }
      if (!v) return;

      if (this.idInput) {
        this.idInput.value = v.id;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const body = this.querySelector('[data-notify-body]');
      if (body) body.value = body.value.replace(/\(.*?\)/, '(' + v.title + ')');
      if (!available) this.resetNotify(v);

      this.renderPrice(v);
      if (v.media) {
        this.goToMedia(v.media);
        const slideImg = this.querySelector('[data-media-id="' + v.media + '"] img');
        const stickyImg = this.querySelector('[data-sticky] img');
        if (slideImg && stickyImg) stickyImg.src = slideImg.currentSrc || slideImg.src;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      this.dispatchEvent(new CustomEvent('ds:variant:change', { bubbles: true, detail: { variant: v } }));
    }

    money(cents) {
      const fmt = this.data.moneyFormat || '$' + '{' + '{amount}}';
      const n = (cents / 100);
      const withDelims = (num, dec, th, de) => {
        const parts = num.toFixed(dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
        return parts.join(de);
      };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
        switch (key) {
          case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
          case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
          default: return withDelims(n, 2, ',', '.');
        }
      }).replace(/<[^>]*>/g, '');
    }

    renderPrice(v) {
      const box = this.querySelector('[data-price]');
      const sale = v.compare > v.price;
      if (box) {
        box.classList.toggle('is-sale', sale);
        const now = box.querySelector('[data-now]');
        const was = box.querySelector('[data-was]');
        const save = box.querySelector('[data-save]');
        if (now) now.textContent = this.money(v.price);
        if (was) was.textContent = sale ? this.money(v.compare) : '';
        if (save) {
          save.hidden = !sale;
          if (sale) save.textContent = 'Save ' + Math.round((v.compare - v.price) * 100 / v.compare) + '%';
        }
      }
      const sp = this.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = this.money(v.price);
      const lowMsg = this.querySelector('[data-low-msg]');
      if (lowMsg) {
        const show = this.low > 0 && v.qty !== null && v.qty > 0 && v.qty <= this.low;
        lowMsg.hidden = !show;
        const n = lowMsg.querySelector('[data-low-n]');
        if (n && show) n.textContent = v.qty;
      }
    }

    step(d) {
      const input = this.querySelector('[data-qty-input]');
      if (!input) return;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + d);
    }

    /* ---------- Add to cart ---------- */
    onSubmit(e) {
      if (!window.DSCore || !window.DSCore.addToCart || !this.atc) return;
      e.preventDefault();
      if (this.atc.disabled || this.atc.classList.contains('is-loading')) return;
      const label = this.atc.querySelector('[data-atc-label]');
      const original = label ? label.textContent : '';
      this.atc.classList.add('is-loading');
      this.atc.setAttribute('aria-busy', 'true');
      this.msg.textContent = '';
      this.msg.classList.remove('is-error');

      window.DSCore.addToCart(new FormData(this.form))
        .then(() => {
          if (label) label.textContent = 'Added';
          const opened = window.DSCore.openCart();
          if (!opened) this.msg.innerHTML = 'Added to cart. <a href="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart">View cart</a>';
          setTimeout(() => { if (label) label.textContent = original; }, 1800);
        })
        .catch((err) => {
          const network = !err.message || /fetch|network/i.test(err.message);
          this.msg.textContent = network ? 'Could not add to cart. Check your connection and try again.' : err.message;
          this.msg.classList.add('is-error');
          const bar = this.querySelector('[data-sticky]');
          if (bar && bar.classList.contains('is-on')) this.msg.scrollIntoView({ block: 'center', behavior: 'smooth' });
        })
        .then(() => {
          this.atc.classList.remove('is-loading');
          this.atc.removeAttribute('aria-busy');
        });
    }

    /* ---------- Gallery ---------- */
    setupGallery() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.cur = this.querySelector('[data-cur]');
      this.index = 0;

      if (this.slides.length > 1 && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((en) => { if (en.isIntersecting) this.mark(this.slides.indexOf(en.target)); });
        }, { root: this.track, threshold: 0.6 });
        this.slides.forEach((sl) => this.io.observe(sl));
      }
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(parseInt(t.dataset.thumb, 10))));
      const prev = this.querySelector('[data-gal-prev]');
      const next = this.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));

      this.querySelectorAll('[data-embed]').forEach((btn) => btn.addEventListener('click', () => {
        const f = document.createElement('iframe');
        f.className = 'ds-gal__frame';
        f.src = btn.dataset.embed;
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.title = btn.getAttribute('aria-label') || 'Product video';
        btn.replaceWith(f);
      }));

      const dlg = this.querySelector('[data-zoom-dialog]');
      if (dlg) {
        this.querySelectorAll('[data-zoom]').forEach((z) => z.addEventListener('click', () => {
          dlg.querySelectorAll('img[data-src]').forEach((img) => { img.src = img.dataset.src; img.removeAttribute('data-src'); });
          if (typeof dlg.showModal === 'function') dlg.showModal(); else return;
          dlg.querySelectorAll('.is-full').forEach((li) => li.classList.remove('is-full'));
          const item = dlg.querySelector('[data-zoom-item="' + z.dataset.zoom + '"]');
          dlg.scrollTop = item ? item.offsetTop : 0;
        }));
        dlg.querySelectorAll('[data-zoom-item] img').forEach((img) => img.addEventListener('click', () => {
          const li = img.closest('li');
          li.classList.toggle('is-full');
          dlg.scrollTop = li.offsetTop;
        }));
        dlg.querySelector('[data-zoom-close]').addEventListener('click', () => dlg.close());
        dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
      }
    }

    /* ---------- Back in stock (Klaviyo) ---------- */
    setupNotify() {
      const form = this.querySelector('form[data-bis]');
      if (!form) return;
      this.bis = form;
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const email = form.querySelector('[data-bis-email]');
        const err = form.querySelector('[data-bis-err]');
        const v = this.current;
        const showErr = (t) => { err.textContent = t; err.hidden = false; };
        err.hidden = true;
        if (!v) return;
        if (!email.value || !email.checkValidity()) { showErr('Please enter a valid email address.'); email.focus(); return; }
        const key = form.dataset.key;
        const headers = { 'Content-Type': 'application/json', revision: '2025-07-15' };
        const profile = { data: { type: 'profile', attributes: { email: email.value.trim() } } };
        const calls = [fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers,
          body: JSON.stringify({ data: {
            type: 'back-in-stock-subscription',
            attributes: { channels: ['EMAIL'], profile },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } }
          } })
        })];
        const optin = form.querySelector('[data-bis-optin]');
        if (optin && optin.checked && form.dataset.list) {
          calls.push(fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
            method: 'POST',
            headers,
            body: JSON.stringify({ data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Back in stock form',
                profile: { data: { type: 'profile', attributes: { email: email.value.trim(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
              },
              relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
            } })
          }).catch(() => null));
        }
        form.classList.add('is-busy');
        Promise.all(calls).then((res) => {
          if (!res[0] || !res[0].ok) throw new Error('bis');
          form.querySelectorAll('[data-bis-fields]').forEach((el) => { el.hidden = true; });
          form.querySelector('[data-bis-done]').hidden = false;
          document.dispatchEvent(new CustomEvent('ds:notify:subscribed', { detail: { variant: v.id } }));
        }).catch(() => {
          showErr('Something went wrong. Please try again in a moment.');
        }).finally(() => form.classList.remove('is-busy'));
      });
    }

    resetNotify(v) {
      const form = this.bis;
      if (!form) return;
      form.querySelectorAll('[data-bis-fields]').forEach((el) => { el.hidden = false; });
      form.querySelector('[data-bis-done]').hidden = true;
      form.querySelector('[data-bis-err]').hidden = true;
      const name = form.querySelector('[data-bis-name]');
      if (name && v && this.data.variants.length > 1) name.textContent = v.title + ' is';
    }

    /* ---------- Wishlist and compare (Ella stores) ---------- */
    setupActions() {
      const wish = this.querySelector('[data-wishlist]');
      if (wish) {
        const sync = () => wish.setAttribute('aria-pressed', wish.classList.contains('wishlist-added') ? 'true' : 'false');
        try {
          const list = JSON.parse(localStorage.getItem('wishlistItem') || '[]');
          if (Array.isArray(list) && list.indexOf(wish.dataset.wishlistHandle) > -1) wish.classList.add('wishlist-added');
        } catch (e) { /* storage blocked */ }
        sync();
        new MutationObserver(sync).observe(wish, { attributes: true, attributeFilter: ['class'] });
      }
      const cmp = this.querySelector('[data-product-compare] input');
      if (cmp) {
        try {
          const list = JSON.parse(localStorage.getItem('compareItem') || '[]');
          cmp.checked = Array.isArray(list) && list.indexOf(cmp.value) > -1;
        } catch (e) { /* storage blocked */ }
      }
    }

    /* ---------- Compare colors ---------- */
    setupCompareColors() {
      const dlg = this.querySelector('[data-cc]');
      const open = this.querySelector('[data-cc-open]');
      if (!dlg || !open) return;
      const checks = Array.from(dlg.querySelectorAll('[data-cc-check]'));
      const show = () => checks.forEach((c) => {
        const item = dlg.querySelector('[data-cc-item="' + c.value + '"]');
        if (item) item.hidden = !c.checked;
      });
      dlg.addEventListener('change', (e) => { if (e.target.matches('[data-cc-check]')) show(); });
      open.addEventListener('click', () => {
        dlg.querySelectorAll('img[data-src]').forEach((img) => { img.src = img.dataset.src; img.removeAttribute('data-src'); });
        if (!checks.some((c) => c.checked)) {
          const fs = this.querySelector('[data-opt="' + dlg.dataset.ccIndex + '"]');
          const cur = fs ? fs.querySelector('input:checked') : null;
          let first = cur ? Array.from(fs.querySelectorAll('input')).indexOf(cur) : 0;
          if (first < 0) first = 0;
          checks.forEach((c, i) => { c.checked = i === first || i === (first + 1) % checks.length; });
        }
        show();
        if (typeof dlg.showModal === 'function') dlg.showModal();
      });
      dlg.querySelector('[data-cc-close]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
      dlg.querySelectorAll('[data-cc-choose]').forEach((b) => b.addEventListener('click', () => {
        const fs = this.querySelector('[data-opt="' + dlg.dataset.ccIndex + '"]');
        const input = fs ? fs.querySelectorAll('input')[parseInt(b.dataset.ccChoose, 10)] : null;
        dlg.close();
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }));
    }

    mark(i) {
      if (i < 0) return;
      this.index = i;
      if (this.cur) this.cur.textContent = i + 1;
      this.thumbs.forEach((t, k) => {
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      /* Scroll only the thumbnail strip. scrollIntoView would also move the page. */
      const t = this.thumbs[i];
      const strip = t && t.closest('.ds-gal__thumbs');
      if (strip) {
        const li = t.parentElement;
        const left = li.offsetLeft - (strip.clientWidth - li.offsetWidth) / 2;
        strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }

    go(i, instant) {
      if (!this.slides || !this.slides.length) return;
      const n = this.slides.length;
      i = ((i % n) + n) % n;
      this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      this.mark(i);
    }

    goToMedia(id, instant) {
      if (!this.slides) return;
      const i = this.slides.findIndex((sl) => sl.dataset.mediaId === String(id));
      if (i > -1) this.go(i, instant);
    }

    /* ---------- Sticky bar ---------- */
    setupSticky() {
      const bar = this.querySelector('[data-sticky]');
      if (!bar || !this.atc || !('IntersectionObserver' in window)) return;
      const btn = bar.querySelector('[data-sticky-btn]');
      btn.addEventListener('click', () => {
        if (this.form && !this.atc.disabled) {
          if (this.form.requestSubmit) this.form.requestSubmit(this.atc); else this.atc.click();
        }
      });
      const toolbar = Array.from(document.querySelectorAll('[class*="toolbar-mobile"]')).find((el) => {
        const cs = getComputedStyle(el);
        return cs.position === 'fixed' && el.offsetHeight > 0 && el.offsetHeight < 120;
      });
      if (toolbar) bar.style.setProperty('--ds-sticky-bottom', toolbar.offsetHeight + 'px');
      const show = (past) => {
        bar.classList.toggle('is-on', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        btn.tabIndex = past ? 0 : -1;
      };
      this.stickyIO = new IntersectionObserver(([en]) => show(!en.isIntersecting && en.boundingClientRect.top < 0));
      this.stickyIO.observe(this.atc);
      /* A jump scroll (anchor link, restored position) can skip the observer, so check once scrolling stops */
      this.onScrollEnd = () => show(this.atc.getBoundingClientRect().bottom < 0);
      window.addEventListener('scrollend', this.onScrollEnd, { passive: true });
    }

    /* ---------- Daily deal ---------- */
    setupDeal() {
      const el = this.querySelector('[data-deal]');
      if (!el) return;
      const end = Date.parse(el.dataset.expires);
      if (isNaN(end)) return;
      const h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      const pad = (x) => String(x).padStart(2, '0');
      const tick = () => {
        const d = end - Date.now();
        if (d <= 0) {
          clearInterval(this.dealTimer);
          el.setAttribute('data-ended', '');
          h.textContent = m.textContent = s.textContent = '00';
          const sub = el.querySelector('[data-deal-sub]');
          if (sub) sub.textContent = 'This deal just ended.';
          return;
        }
        h.textContent = pad(Math.floor(d / 3600000));
        m.textContent = pad(Math.floor((d % 3600000) / 60000));
        s.textContent = pad(Math.floor((d % 60000) / 1000));
      };
      tick();
      this.dealTimer = setInterval(tick, 1000);
    }

    /* ---------- Share ---------- */
    setupShare() {
      const btn = this.querySelector('[data-share]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const url = window.location.href;
        if (navigator.share) { navigator.share({ title: btn.dataset.title, url: url }).catch(() => {}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => {
          const l = btn.querySelector('[data-share-label]');
          if (l) { l.textContent = 'Link copied'; setTimeout(() => { l.textContent = 'Share'; }, 2000); }
        });
      });
    }

    disconnectedCallback() {
      this._ready = false;
      if (this.io) this.io.disconnect();
      if (this.stickyIO) this.stickyIO.disconnect();
      if (this.onScrollEnd) window.removeEventListener('scrollend', this.onScrollEnd);
      clearInterval(this.dealTimer);
    }
  });
}
